import React, { ReactNode } from "react";
import { Head, router } from "@inertiajs/react";
import { ArrowRight } from "lucide-react";
import ReviewsForm from "../../components/ReviewsForm";
import NomineeLayout from "./components/NomineeLayout";
import TrophyBanner from "./components/TrophyBanner";
import NomineeFooter from "./components/NomineeFooter";
import { NomineePage } from "./types";

type NomineesShowProps = {
  nominee: NomineePage;
};

const NomineesShow: React.FC<NomineesShowProps> & {
  layout?: (page: ReactNode) => ReactNode;
} = ({ nominee }) => {
  return (
    <>
      <Head>
        <title>{`Votez pour la ${nominee.name} - Trophées des Véhicules Électriques 2026`}</title>
        <meta
          name="description"
          content={`Donnez votre avis et votez pour la ${nominee.name} aux Trophées des Véhicules Électriques 2026.`}
        />
      </Head>
      <TrophyBanner type={nominee.type} />
      <main className="flex flex-col items-center px-4 pt-10 pb-16 lg:pt-16">
        <h1 className="text-center text-4xl lg:text-6xl font-bold leading-tight mb-8 lg:mb-12">
          Votez pour la
          <span className="block text-primary">{nominee.name}</span>
        </h1>
        <ReviewsForm
          licensePlate={{
            title: `Trouvez votre modèle ${nominee.name} en un clic`,
            tagline: null,
            buttonLabel: (
              <>
                Commencer
                <ArrowRight className="size-4" />
              </>
            ),
          }}
          onSuccess={() => router.visit("/reviews")}
        />
        <img
          src={nominee.image}
          alt={nominee.name}
          className="w-full max-w-2xl mt-6"
        />
      </main>
      <NomineeFooter />
    </>
  );
};

NomineesShow.layout = (page) => <NomineeLayout>{page}</NomineeLayout>;

export default NomineesShow;
